import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Grid, Card } from "@mui/material";
import { theme, StyledMultilineTextField } from "../StyledComponents";
import { FIELD_SET_IDS } from "../config/defaults/fieldLayoutUtils";
import useSectionFieldLayout from "../config/hooks/useSectionFieldLayout";

const MedicalAdvice = ({
  sectionName,
  activeSection,
  data,
  setData,
  fieldLayout: fieldLayoutProp,
}) => {
  const fieldLayout = useSectionFieldLayout(
    fieldLayoutProp,
    FIELD_SET_IDS.medicalAdvice,
  );

  const handleInputChange = (field, value) => {
    let updatedDetails = { ...data, [field]: value };

    setData(updatedDetails);
  };

  return (
    <ThemeProvider theme={theme}>
      {activeSection ? (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          <Grid container spacing={2} sx={{ padding: "10px" }}>
            {fieldLayout.isFieldVisible("advice") && (
              <Grid item {...fieldLayout.getFieldGrid("advice", { xs: 12, sm: 12, md: 12 })}>
                <StyledMultilineTextField
                  id="outlined-multiline-static"
                  label={fieldLayout.getFieldLabel("advice", "Medical Advice")}
                  multiline
                  rows={2}
                  value={data.advice || ""}
                  onChange={(e) => handleInputChange("advice", e.target.value)}
                  fullWidth
                  error={!data.advice?.trim() && fieldLayout.isFieldRequired("advice")}
                  helperText={
                    !data.advice?.trim() && fieldLayout.isFieldRequired("advice")
                      ? "Medical Advice is a mandatory field."
                      : ""
                  }
                />
              </Grid>
            )}
          </Grid>
        </Card>
      ) : null}
    </ThemeProvider>
  );
};

export default MedicalAdvice;
